import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack';
import CheckboxField from '@grnhse/seedling/lib/birch/components/forms/fields/checkbox_field';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.filter_row.manual_review');

export const ManualReviewContent = () => {
  return (
    <Stack spacing={2} direction="column">
      <CheckboxField
        name="manualReview"
        label={t('checkbox_label')}
        ariaLabel={t('description')}
        value="manualReview"
      />
    </Stack>
  );
};
